<template>
  <div class="app-category-manager">
    <div class="app-category-manager__header">
      <el-button type="primary" size="small" @click="handleAddNewCategory">添加分类</el-button>
    </div>
    <div class="app-category-manager__body">
      <el-table class="app-category-manager__table" :data="category.categories" size="small" style="width: 100%" border>
        <el-table-column prop="name" label="分类名称"></el-table-column>
        <el-table-column label="分类图片">
          <template slot-scope="scope">
            <img class="app-category-manager__image" :src="scope.row.imageList | showFirstImage" alt="分类图">
          </template>
        </el-table-column>
        <el-table-column prop="productCount" label="产品/商品数"></el-table-column>
        <el-table-column prop="createdAt" label="创建时间">
          <template slot-scope="scope">{{ scope.row.createdAt | formatDate('YYYY-MM-DD', 's') }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleDeleteCategory(scope.row)">删除</el-button>
            <el-button type="text" size="mini" @click="handleEditCategory(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="app-category-manager__footer" v-if="category.total > limit">
      <el-pagination :total="category.total" :page-size="limit" @current-change="handlePageChange" layout="prev, pager, next"></el-pagination>
    </div>
    <app-category-editor-dialog
      :title="subdialog.title"
      :visible="subdialog.visible"
      :category="subdialog.category"
      @close="hideSubdialog"
      @ok="handleSubdialogOk">
    </app-category-editor-dialog>
  </div>
</template>

<script>
import AppCategoryEditorDialog from '../AppCategoryEditorDialog'

export default {
  name: 'AppCategoryManager',
  components: {
    AppCategoryEditorDialog
  },

  data () {
    return {
      subdialog: {
        title: '添加分类',
        visible: false,
        category: this.getEmptyCategory()
      },
      offset: 0,
      limit: 5
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },

    category () {
      const { total, categories } = this.$store.state.category
      return { total, categories }
    }
  },

  methods: {
    getEmptyCategory () {
      return {
        name: '',
        imageList: []
      }
    },

    deleteCategory (id, cb) {
      this.$store.dispatch('deleteCategory', {
        params: {
          userId: this.user.id,
          categoryId: id
        }
      }).then(response => {
        cb && cb(null)
      }).catch(error => {
        cb && cb(error)
      })
    },

    getCategories () {
      this.$store.dispatch('getCategories', {
        query: {
          offset: this.offset * this.limit,
          limit: this.limit
        },
        params: { userId: this.user.id }
      })
    },

    hasProduct (category, cb) {
      if (category.productCount > 0) {
        this.$alert('当前分类下含有产品，无法进行删除操作！', '无法删除', {
          type: 'warning',
          showClose: false,
          confirmButtonText: '我知道了'
        }).catch(() => {
          // No handler
        })
      } else {
        cb && cb()
      }
    },

    confirmDelete (cb) {
      this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
        type: 'warning',
        showClose: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        cb && cb()
      }).catch(() => {
        // No handler
      })
    },

    showSubdialog () {
      this.subdialog.visible = true
    },

    hideSubdialog () {
      this.subdialog.visible = false
    },

    handleAddNewCategory () {
      this.subdialog.title = '添加分类'
      this.subdialog.category = this.getEmptyCategory()
      this.showSubdialog()
    },

    handleDeleteCategory (category) {
      this.hasProduct(category, () => {
        this.confirmDelete(() => {
          this.deleteCategory(category.id, (error) => {
            if (error) {
              this.$message({
                type: 'warning',
                message: '删除分类失败！'
              })
            } else {
              this.offset = 0
              this.getCategories()
              this.$message({
                type: 'success',
                message: '删除分类成功!'
              })
            }
          })
        })
      })
    },

    handleEditCategory (category) {
      this.subdialog.title = '编辑分类'
      this.subdialog.category = category
      this.showSubdialog()
    },

    handleSubdialogOk () {
      this.getCategories()
      this.hideSubdialog()
    },

    handlePageChange (page) {
      this.offset = --page
      this.getCategories()
    }

  }
}
</script>

<style lang="scss">
.app-category-manager {
  color: #333;

  &__table th {
    padding: 5px 0;
    background-color: #f8f8f8;
  }

  // &__header {}

  &__body {
    margin-top: 10px;
  }

  &__footer {
    margin-top: 15px;
    text-align: right;
  }

  &__image {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    object-fit: cover;
  }
}
</style>
